import cn from './styles.module.sass';

export const ActiveFilterContentWithTotal = ({
    totalSelected,
    filterName,
}: {
    totalSelected?: number;
    filterName?: string;
}) => {
    return (
        <>
            <span className={cn.totalSelected}>{totalSelected}</span>
            <span className={cn.filterName}>{filterName}</span>
        </>
    );
};
